import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface ClientTypeEditorViewProps {
    label?: string;
    value: number | null;
    onChanged: (number: number | null) => void;
    onGetErrorMessage?: () => Promise<ValidationError[]>;
    required?: boolean;
    mode: ControlMode;
}

export class ClientTypeEditorView extends React.Component<ClientTypeEditorViewProps, any> {
    public constructor(props) {
        super(props);
    }

    public render() {
        return (
            <DropdownView label={this.props.label === undefined ? 'Type' : this.props.label}
                model={this.props.value}
                required={this.props.required}
                onChanged={(item) => { this.props.onChanged(item != null ? item.value : null) }}
                options={
                    [
                        { value: 0, label: 'Person' },
                        { value: 1, label: 'Company' },
                        { value: 2, label: 'Group' }
                    ]
                }
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/parts/clienttype-editor.view.tsx